import React from 'react';
import { useSelector } from 'react-redux';
import {
    Route,
    Redirect
} from 'react-router-dom';

import MainContainer from '../components/main-container';

const TemplateRoute = ({ component: Component, ...rest }) => {

    const isAuthenticated = useSelector(state => state.authenReducer.isAuthenticate);

    const renderComponent = (props) => {

        if (!isAuthenticated) {
            return (
                <Redirect
                    to={{
                        pathname: "/",
                        state: {
                            from: props.location,
                        }
                    }}
                />
            )
        }

        return (
            <MainContainer>
                <Component {...props}/>
            </MainContainer>
        )
    }

    return (
        <Route
            {...rest}
            render={props => renderComponent(props)}
        />
    )
}

export default TemplateRoute;